// extracted by mini-css-extract-plugin
export default {"nameSection":"BenefitsCMSBlock_nameSection__2OStA","costSection":"BenefitsCMSBlock_costSection__tWQzJ","chevronSection":"BenefitsCMSBlock_chevronSection__ml0mJ"};